export const SECTION_CODES = {
  platformCustomization: 'crm.settings.platformCustomization',
  companyInformation: 'crm.settings.companyInformation',
  billing: 'crm.settings.billing',
  aiDataPolicy: 'crm.settings.aiDataPolicy',
} as const;
